const normalizeAssetPath = (assetPath: string) => assetPath.replace(/^\.?\/+/, "");

export const getPublicAssetUrl = (assetPath: string) => {
  const normalizedAssetPath = normalizeAssetPath(assetPath);
  const baseUrl = process.env.BASE_URL || "./";

  return `${baseUrl}${normalizedAssetPath}`;
};